const submenuOpenClass = 'submenu-open';
const navOpenClass = 'nav-open';

export function positionLogo() {
    const docEl = $(document.documentElement);
    const header = $('.page-header');
    const nav = header.find('.page-header-nav');
    const logoImg = header.find('.page-header-logo img');
    const paddingTop = 40;
    $(window).scroll(function () {
        _setPos();
    });
    _setPos();

    function _setPos() {
        if (docEl.hasClass('mobile-header')) {
            logoImg.css('transform', '');
            return;
        }

        const imgRect = logoImg[0].getBoundingClientRect();
        const {scrollY} = window;
        const translate = Math.min(scrollY, imgRect.height - nav.height() + paddingTop);

        logoImg.css('transform', `translateY(${translate}px)`);
    }
}

export function mobileHeader() {
    const pageHeader = $('.page-header');
    const docEl = $(document.documentElement);
    $('.slide-open').click(function (e) {
        e.preventDefault();
        $(this).parents('.menu-item')
            .find('.menu')
            .addClass('open');
        pageHeader.addClass(submenuOpenClass);
    });
    $('.slide-close').click(function () {
        this.blur();
        const parentMenu = $(this).closest('.menu');
        if (parentMenu.hasClass('level-1')) {
            pageHeader.removeClass(navOpenClass);
        } else {
            parentMenu.removeClass('open');
        }
        pageHeader.removeClass(submenuOpenClass);
    });

    let lastClicked = null;
    $('.level-1 > .menu-item > .menu-link').on('touchend', function (e) {
        if (docEl.hasClass('mobile-header')
            || !$(this).parent().hasClass('is-parent')
            || lastClicked === this) {
            return;
        }
        e.preventDefault();
        this.focus();


        $(this).one('blur', function () {
            lastClicked = null;
        });

        lastClicked = this;
    });

    $('.page-header-mobile-open button').click(function () {
        pageHeader.addClass('nav-open');
    });

    $('.page-header-close-zone').click(function () {
        if (pageHeader.hasClass(submenuOpenClass)) {
            $('.level-2').removeClass('open');
            pageHeader.removeClass(submenuOpenClass);
            return;
        }
        pageHeader.removeClass(navOpenClass);
    });
}

export function mobileAd() {
    const root = $(document.documentElement);

    if (root.hasClass('mobile-header')) {
        root.toggleClass('mobile-ad-hidden', window.scrollY > 200);
    }

    window.addEventListener('scroll', () => {
        if (root.hasClass('mobile-header')) {
            root.toggleClass('mobile-ad-hidden', window.scrollY > 200);
        }
    }, {passive: true});
}